"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSize = void 0;
// (C) 2007-2020 GoodData Corporation
var AutoSize_1 = require("./AutoSize");
Object.defineProperty(exports, "AutoSize", { enumerable: true, get: function () { return AutoSize_1.AutoSize; } });
//# sourceMappingURL=index.js.map